import React from 'react';
import styled from 'styled-components';
import Colors from 'bit/mobiauto.web-ui-components.components.colors/colors';
import Grid from '@material-ui/core/Grid';
import { ReactComponent as AppleStore } from 'assets/apple-store.svg';
import { ReactComponent as GooglePlay } from 'assets/google-play.svg';
import { Desktop, Mobile } from 'components/Responsive';
import { LinkExternal } from 'components/Link';

const TextRight = styled.div`
  font-family: Poppins Bold;
  font-size: 14px;
  line-height: 1;
  color: #fff;
  justify-content: right;
  align-items: center;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
`;

const TextRightMobile = styled.div`
  font-family: Poppins Bold;
  font-size: 14px;
  line-height: 1;
  color: #fff;
  justify-content: space-evenly;
  align-items: center;
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 8px;
`;
const Policy = styled.div`
  font-family: Poppins Regular;
  font-size: 10px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  display: flex;
  align-items: center;
  flex-direction: center;
  color: ${Colors.gray.medium};
`;

const PolicyMobile = styled.div`
  font-family: Poppins Regular;
  font-size: 10px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  display: flex;
  align-items: center;
  flex-direction: center;
  margin-top: 16px;
  color: ${Colors.gray.medium};
`;
const WrapperMobile = styled.div`
  width: 100%;
  height: 149px;
  display: flex;
  flex-direction: column;
  background-color: ${Colors.gray.light};
`;
const Wrapper = styled.footer`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 80px;
  align-items: center;
  justify-content: center;
  height: 59px;

  background-color: ${Colors.gray.light};
`;

const Footer = () => {
  const currentVersion = localStorage.getItem('mobigestorVersion');
  return (
    <React.Fragment>
      <Desktop>
        <Wrapper style={{ boxSizing: 'border-box' }}>
          <Grid container direction="row" justify="space-between">
            <div style={{ display: 'flex', alignSelf: 'center', gap: '8px' }}>
              <div>Versão: {currentVersion}</div>
              <Policy>
                Verifique a nossa Política de Privacidade e Termos de Uso.
              </Policy>
            </div>
            <TextRight>
              <Policy>Baixe o nosso Aplicativo:</Policy>
              <LinkExternal
                href={
                  'https://play.google.com/store/apps/details?id=br.com.mobiauto.revendedor'
                }
              >
                <GooglePlay
                  style={{ width: 'auto', height: '40px', marginLeft: '24px' }}
                />
              </LinkExternal>
              <LinkExternal
                href={
                  'https://apps.apple.com/br/app/mobiauto-gestor/id1469897220'
                }
              >
                <AppleStore style={{ width: 'auto', height: '45px' }} />
              </LinkExternal>
            </TextRight>
          </Grid>
        </Wrapper>
      </Desktop>
      <Mobile>
        <WrapperMobile>
          <Grid
            container
            direction="column"
            justify="center"
            alignItems="center"
          >
            <PolicyMobile>Baixe o nosso Aplicativo:</PolicyMobile>

            <TextRightMobile>
              <LinkExternal
                href={
                  'https://play.google.com/store/apps/details?id=br.com.mobiauto.revendedor'
                }
              >
                <GooglePlay style={{ width: 'auto', height: '40px' }} />
              </LinkExternal>
              <LinkExternal
                href={
                  'https://apps.apple.com/br/app/mobiauto-gestor/id1469897220'
                }
              >
                <AppleStore style={{ width: 'auto', height: '40px' }} />
              </LinkExternal>
            </TextRightMobile>
            <PolicyMobile>
              Verifique a nossa Política de Privacidade e Termos de Uso.
            </PolicyMobile>
          </Grid>
        </WrapperMobile>
      </Mobile>
    </React.Fragment>
  );
};

export default Footer;
